<template>
  <div id="app">
    <router-view />
    <install-prompt />
  </div>
</template>

<script>
import "./assets/styles/main.scss";
import InstallPrompt from "@/components/InstallPrompt.vue";

export default {
  components: { InstallPrompt },
};
</script>
